import text from "../Json/Text.json";

const TextFetcher = (prop,lang) => {
    if(!prop && !lang)
        return null;
    if(!prop && lang)
        return text[lang];
    
    return text[lang][prop];
}

export default TextFetcher;